module.exports = __webpack_public_path__ + "img/data_tang_1.f5902a44.png";